// extracted by mini-css-extract-plugin
export default {"table_wrapper":"GajiPokok_table_wrapper__COvnR"};